import { useEffect, useState } from "react";
import { ListContent, ListItem, ListLabel, ListText } from "./Style";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";


interface TmpListItemCustomProps {
    label: string;
    id?: string;
    tabIndex?: number;
    role?: string;
    text?: string;
    className?: string;
    leadingIcon?: React.ReactElement;
    trailingIcon?: React.ReactElement;
    handleClick?: (e: any) => void;
    keyDown?: (e: any) => void;
}

export default function TmpListItemCustom(props: TmpListItemCustomProps) {

    const [_type, setType] = useState("single");

    useEffect(() => {
        setType(props.text ? "double" : "single");
    }, [props.text]);

    const _handleClick = (e: any) => {
        if (props.handleClick) {
            props.handleClick(e);
        }
    };

    const _keyDown = (e: any) => {
        if (props.keyDown) {
            props.keyDown(e);
        }
    };

    // Passing style props to styled component
    ListItem.defaultProps = style;
    ListContent.defaultProps = style;
    ListLabel.defaultProps = style;
    ListText.defaultProps = style;

    return (
        <ListItem
            id={props.id}
            role={props.role}
            tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
            isAction={props.handleClick !== undefined ? true : false}
            className={"tmp-list-item " + props.className}
            onClick={_handleClick}
            onKeyDown={_keyDown}
            data-testid="list_item"
        >
            {props.leadingIcon && (
                <TmpIconCustom
                    className="tmp-list-item__leading-icon"
                    size="md"
                    icon={props.leadingIcon}
                />
            )}
            {_type === "single" ? (
                <ListContent>
                    <ListLabel type={_type}>{props.label}</ListLabel>
                </ListContent>
            ) : (
                <ListContent>
                    <ListLabel type={_type}>{props.label}</ListLabel>
                    <ListText>{props.text}</ListText>
                </ListContent>
            )}

            {props.trailingIcon && (
                <TmpIconCustom
                    className="tmp-list-item__trailing-icon"
                    size="md"
                    icon={props.trailingIcon}
                />
            )}
        </ListItem>
    );
}

